"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const brain_1 = __importDefault(require("../types/brain"));
const communication_1 = __importDefault(require("../types/communication"));
const genius_1 = __importDefault(require("../types/genius"));
const management_1 = __importDefault(require("../types/management"));
const motivation_1 = __importDefault(require("../types/motivation"));
const position_1 = __importDefault(require("../types/position"));
const response_1 = __importDefault(require("../types/response"));
const vector_1 = __importDefault(require("../types/vector"));
const createGeniusRecord_1 = __importDefault(require("../utils/createGeniusRecord"));
const masterData_json_1 = require("../masterData.json");
const bizRecords_1 = __importDefault(require("./bizRecords"));
const loveRecords_1 = __importDefault(require("./loveRecords"));
/** The list that the details corresponding to personality type. */
exports.default = createGeniusRecord_1.default(masterData_json_1.detailsMap.map((row, index) => ({
    affinity: {
        biz: bizRecords_1.default[genius_1.default[index]],
        love: loveRecords_1.default[genius_1.default[index]],
    },
    brain: brain_1.default[row[5]],
    communication: communication_1.default[row[0]],
    management: management_1.default[row[1]],
    motivation: motivation_1.default[row[4]],
    position: position_1.default[row[3]],
    response: response_1.default[row[2]],
    vector: vector_1.default[row[6]],
})));
//# sourceMappingURL=details.js.map